export const articles = [
  {
    id: 1,
    title: '当优雅遇见野性：打破常规的穿搭哲学',
    slug: 'youya-yexing-dapei-zhexue',
    excerpt: '真正的风格不在于遵循规则，而在于打破规则。探索如何在优雅的裙摆之下，释放你内心那头沉睡的野兽。',
    content: `<p>在时尚的世界里，优雅与野性从来不是对立的两面。相反，它们如同一枚硬币的两面，共同构成了女性气质的完整表达。</p>
    <p>传统的时尚观念总是试图将女性框定在某些固定的形象里：要么是温婉柔美的淑女，要么是狂放不羁的野丫头。但真正的现代女性，早已超越了这种二元对立的桎梏。</p>
    <h3>优雅是铠甲，野性是内核</h3>
    <p>一条精致的丝绸长裙，配上一双粗犷的军靴；一件剪裁利落的西装外套，内搭一件性感的蕾丝吊带——这种看似矛盾的组合，恰恰是当代女性力量的最佳注脚。</p>
    <p>优雅是你向世界展示的面孔，而野性则是你留给自己的真实。当一个女人学会在两者之间自由切换，她就拥有了真正不可战胜的力量。</p>
    <h3>从T台到街头：野性美学的日常化</h3>
    <p>不需要等到参加派对才敢释放你的野性。在日常穿搭中，一个金属质感的配饰、一双动物纹的鞋子、或者一抹大胆的红唇，都能让你的优雅造型瞬间注入一股不驯的力量。</p>
    <p>关键不在于穿什么，而在于你如何穿着它。同样的衣服，在一个自信的女人身上，会有完全不同的生命力。</p>`,
    category: '优雅叛逆',
    categorySlug: 'youya-panni',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20of%20a%20woman%20wearing%20elegant%20beige%20silk%20midi%20dress%20with%20edgy%20black%20leather%20jacket%20contrast%2C%20standing%20confidently%2C%20warm%20studio%20lighting%2C%20cream%20minimalist%20background%2C%20luxury%20fashion%20aesthetic%2C%20high%20fashion%20editorial%20style%2C%20dramatic%20composition&width=600&height=400&seq=article-1&orientation=landscape',
    author: '林晚晴',
    date: '2026-07-28',
    readTime: '8 分钟',
    tags: ['穿搭哲学', '风格宣言', '野性美学'],
  },
  {
    id: 2,
    title: '从束缚到解放：女性时尚的百年野性进化史',
    slug: 'shufu-dao-jiefang-nvxing-shishang',
    excerpt: '回望一个世纪以来，女性如何通过时装一步步挣脱束缚，从紧身胸衣到权力套装，每一次变革都是一次野性的觉醒。',
    content: `<p>如果说时尚是一面镜子，那么它映照出的，正是女性在社会中地位的变迁。从20世纪初的紧身胸衣，到今天无拘无束的oversize风潮，每一步都是一场静默而坚定的革命。</p>
    <h3>1920年代：第一次解放</h3>
    <p>当Flapper女孩们剪短头发、抛弃束腰、穿上直筒连衣裙，她们不仅在改变着装方式，更在宣告：女性的身体属于自己。</p>
    <h3>1960-70年代：第二次浪潮</h3>
    <p>迷你裙的出现引发了一场地震。Mary Quant和André Courrèges用剪刀宣告了一个新时代的到来。与此同时，Yves Saint Laurent的吸烟装让女性第一次光明正大地穿上了男人的衣服——这是一种何等野性的挑衅。</p>
    <h3>1980年代：权力与肩线</h3>
    <p>宽肩西装、凌厉的线条，女性用时装告诉世界：我们不需要变得像男人一样才能获得权力，我们可以用自己的方式定义力量。</p>
    <h3>今天：无边界时代</h3>
    <p>当下，性别流动、无季节穿搭、可持续时尚——一切边界都在消融。而这，正是野性最纯粹的状态：不被任何框架所定义。</p>`,
    category: '野性力量',
    categorySlug: 'yexing-liliang',
    coverImage: 'https://readdy.ai/api/search-image?query=Vintage%20fashion%20collage%20style%20editorial%20photography%2C%20evolution%20of%20women%20fashion%20through%20decades%2C%20dramatic%20silhouettes%20from%20different%20eras%2C%20warm%20sepia%20and%20cream%20tones%2C%20minimalist%20museum%20gallery%20background%2C%20artistic%20fashion%20history%20concept%2C%20elegant%20composition&width=600&height=400&seq=article-2&orientation=landscape',
    author: '苏念真',
    date: '2026-07-25',
    readTime: '12 分钟',
    tags: ['时尚历史', '女性力量', '野性进化'],
  },
  {
    id: 3,
    title: '暗夜玫瑰：如何用黑色打造致命吸引力',
    slug: 'anye-meigui-heise-meili',
    excerpt: '黑色是野性最忠实的盟友。从哥特到极简，从蕾丝到皮革，教你用黑色穿出令人窒息的魅力。',
    content: `<p>在所有颜色中，黑色是最具野性气质的。它不解释、不妥协、不讨好。一件完美的黑色单品，胜过千言万语。</p>
    <h3>全黑不等于无聊</h3>
    <p>很多人害怕全黑造型会显得单调。但真正懂得黑色的人知道，黑色的力量恰恰在于它的层次感——不同材质的黑色在这个光谱上各自闪耀：丝绸的流光、皮革的哑光、蕾丝的透光、天鹅绒的吸光……</p>
    <h3>黑色配方的三个层次</h3>
    <p>第一层：选择一件核心黑色单品，它应该是造型的锚点——一条剪裁完美的黑色连衣裙，或一件质感上乘的黑色皮衣。</p>
    <p>第二层：用不同材质来创造对比。比如在皮质外套内搭一件丝质衬衫，下半身选择一条毛呢长裤。</p>
    <p>第三层：金属配饰是你的秘密武器。金色的耳环、银色的手链——在黑色的背景上，一点点金属光泽就是最致命的吸引力。</p>`,
    category: '暗夜魅力',
    categorySlug: 'anye-meili',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20of%20a%20woman%20in%20all%20black%20ensemble%20featuring%20textured%20layers%20silk%20leather%20and%20lace%2C%20dramatic%20moody%20lighting%20with%20gold%20accent%20jewelry%2C%20cream%20minimalist%20studio%20background%2C%20luxury%20dark%20fashion%20aesthetic%2C%20high%20contrast%20editorial%20style&width=600&height=400&seq=article-3&orientation=landscape',
    author: '林晚晴',
    date: '2026-07-22',
    readTime: '7 分钟',
    tags: ['黑色穿搭', '暗黑美学', '风格指南'],
  },
  {
    id: 4,
    title: '自由的尺度：极简主义中的不驯态度',
    slug: 'ziyou-chidu-jijian-zhuyi',
    excerpt: '极简不等于温顺。在最少的线条和色彩中，藏着最强烈的态度。探索如何用极简主义表达你的野性。',
    content: `<p>人们常常误解极简主义——他们以为极简就是温和、退让、没有性格。但真正的极简主义者知道，少即是多的背后，是一种更强大的掌控力。</p>
    <h3>减法美学中的力量</h3>
    <p>想象一件没有任何装饰的白色衬衫。没有蕾丝、没有褶皱、没有多余的线条。但在它精准的剪裁中，在面料与身体之间若即若离的关系里，隐藏着一种不容置疑的力量——我选择不装饰，因为我本身就是装饰。</p>
    <h3>结构的野性</h3>
    <p>极简主义的野性，藏在结构中。当一件外套的肩线精准到毫米，当一条裤子的廓形干净到没有一丝犹豫，这种极致的控制本身，就是一种宣言：我清楚地知道自己要什么。</p>`,
    category: '极简界限',
    categorySlug: 'jijin-jiexian',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20photography%20of%20a%20woman%20in%20architectural%20minimalist%20white%20ensemble%20with%20sharp%20clean%20lines%20and%20bold%20structure%2C%20soft%20studio%20lighting%2C%20warm%20cream%20minimalist%20background%2C%20sophisticated%20modern%20fashion%20aesthetic%2C%20editorial%20composition%20with%20geometric%20simplicity&width=600&height=400&seq=article-4&orientation=landscape',
    author: '苏念真',
    date: '2026-07-20',
    readTime: '6 分钟',
    tags: ['极简主义', '风格态度', '穿搭指南'],
  },
  {
    id: 5,
    title: '裙摆下的战靴：当代女性的双重武装',
    slug: 'qunbai-zhangxue-nvxing-wuzhuang',
    excerpt: '当飘逸的裙摆遇上一双利落的战靴，两种看似矛盾的元素在碰撞中诞生了当代女性最有力的风格宣言。',
    content: `<p>裙子和靴子的组合，是当代女性风格中最具代表性的一种搭配。它完美地诠释了「裙子下面是野兽」的核心理念。</p>
    <h3>矛盾的和谐</h3>
    <p>一条柔美飘逸的雪纺长裙，配上一双厚底的马丁靴——这种搭配之所以迷人，正是因为它的矛盾性。裙摆的每一次飘动都在诉说着温柔，而靴子踏在地面的每一个声响都在宣告着力量。</p>
    <p>这不正是当代女性最真实的写照吗？我们可以在会议桌上优雅从容，也可以在需要时展现出钢铁般的意志。</p>
    <h3>如何驾驭这种风格</h3>
    <p>关键之一在于比例。如果是长裙，选择一双有存在感的靴子来平衡整体视觉重量；如果是短裙，可以利用靴子的高度来拉长腿部线条。</p>
    <p>另一个关键是材质。纱裙配皮质靴、丝绸裙配麂皮靴、针织裙配漆皮靴——不同材质的碰撞本身就是一种视觉享受。</p>`,
    category: '优雅叛逆',
    categorySlug: 'youya-panni',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20of%20a%20woman%20wearing%20a%20flowing%20cream%20chiffon%20midi%20skirt%20with%20chunky%20black%20combat%20boots%2C%20contrasting%20soft%20and%20tough%20elements%2C%20warm%20studio%20lighting%2C%20minimalist%20cream%20background%2C%20modern%20editorial%20fashion%20style&width=600&height=400&seq=article-5&orientation=landscape',
    author: '林晚晴',
    date: '2026-07-18',
    readTime: '8 分钟',
    tags: ['裙装穿搭', '风格混搭', '女性力量'],
  },
  {
    id: 6,
    title: '不驯之美：那些改变时尚规则的女性偶像',
    slug: 'buxun-zhi-mei-nvxing-ouxiang',
    excerpt: '从Coco Chanel到Rihanna，这些女性用她们的穿着方式，一次又一次地改写了时尚的规则，释放了女性的野性力量。',
    content: `<p>在时尚的历史长卷中，总有那么一些女性，她们拒绝遵守规则——她们自己就是规则。</p>
    <h3>Coco Chanel：第一个偷穿男人衣服的女人</h3>
    <p>当Chanel把男装的面料和剪裁引入女装，她做的远不止是创造了一种新风格。她告诉所有女性：你们可以穿任何你们想穿的衣服，没有任何禁区。</p>
    <h3>Katharine Hepburn：裤装革命</h3>
    <p>在好莱坞的黄金年代，当所有女星都穿着华丽的礼服裙出现在镜头前时，Hepburn穿着宽大的裤子大步走过。这种在今天看来稀松平常的选择，在当时无异于一场革命。</p>
    <h3>今天的继承者们</h3>
    <p>Tilda Swinton的中性美学、Rihanna的孕妇时尚革命、Zendaya的红毯实验——每一位都在用自己的方式继续着这场未竟的野性事业。</p>`,
    category: '野性力量',
    categorySlug: 'yexing-liliang',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20montage%20featuring%20iconic%20women%20fashion%20revolutionaries%20through%20history%2C%20dramatic%20black%20and%20white%20with%20warm%20cream%20tones%2C%20minimalist%20gallery%20wall%20background%2C%20elegant%20artistic%20composition%2C%20timeless%20fashion%20aesthetic&width=600&height=400&seq=article-6&orientation=landscape',
    author: '苏念真',
    date: '2026-07-15',
    readTime: '10 分钟',
    tags: ['时尚偶像', '女性力量', '风格革命'],
  },
  {
    id: 7,
    title: '流浪的诗意：波西米亚风格的野性表达',
    slug: 'liulang-shiyi-bohemian-yexing',
    excerpt: '波西米亚风格从来不只是关于花朵和流苏——它关于自由、流浪和拒绝被驯服的精神。重新发现波西米亚中的野性基因。',
    content: `<p>波西米亚风格常常被误解为一种甜美的、田园诗般的风格。但它的根源远比表面的花边和刺绣要深刻得多。</p>
    <h3>吉普赛灵魂</h3>
    <p>真正的波西米亚精神来自流浪的吉普赛文化——一种拒绝定居、拒绝被规训的生活方式。当这种精神被转译为时装，它变成了层叠的裙摆、混搭的花纹、来自不同文化的元素被自由组合在一起。</p>
    <h3>当代波西米亚</h3>
    <p>今天的波西米亚风格已经进化。它不再只是花朵裙和麂皮靴，而是更多地体现在一种态度上：我不属于任何地方，但我可以属于任何地方。一件来自摩洛哥的刺绣外套，搭配一条日式宽腿裤，再配上一双意大利手工凉鞋——这不是混乱，这是自由。</p>`,
    category: '自由灵魂',
    categorySlug: 'ziyou-linghun',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20of%20a%20woman%20in%20layered%20bohemian%20style%20with%20mixed%20patterns%20and%20textures%2C%20flowing%20fabrics%20in%20warm%20earth%20tones%2C%20natural%20light%20streaming%20through%20windows%2C%20minimalist%20cream%20studio%20background%2C%20artistic%20free%20spirit%20fashion%20aesthetic&width=600&height=400&seq=article-7&orientation=landscape',
    author: '林晚晴',
    date: '2026-07-12',
    readTime: '7 分钟',
    tags: ['波西米亚', '自由风格', '穿搭灵感'],
  },
  {
    id: 8,
    title: '皮革与蕾丝：当硬核遇见柔软',
    slug: 'pige-leisi-yinghe-ruan',
    excerpt: '皮革和蕾丝是野性与优雅最经典的对话。学会驾驭这对矛盾组合，你就掌握了风格中最强大的张力。',
    content: `<p>皮革和蕾丝的组合，是「裙子下面是野兽」最直接、最经典的表达。它们代表了女性气质的两个极端——蕾丝的柔美与皮革的强硬——而当这两种材质被放在一起，产生的化学反应是惊人的。</p>
    <h3>张力的艺术</h3>
    <p>一条蕾丝连衣裙外面随意披上一件机车皮衣，这种搭配之所以永不过时，是因为它完美地捕捉了当代女性精神的核心：既要有柔软的一面，也要有坚强的铠甲。</p>
    <h3>搭配秘诀</h3>
    <p>不要让皮革和蕾丝的面积相等——保持一种材料为主导，另一种为点缀。如果蕾丝是主角（比如一条蕾丝连衣裙），那么皮衣应该是短款或开衫式，起到框架作用；如果皮革是主角（比如一条皮裤），那么蕾丝应该在上半身以细节的方式出现。</p>`,
    category: '暗夜魅力',
    categorySlug: 'anye-meili',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20of%20a%20woman%20wearing%20black%20leather%20moto%20jacket%20over%20a%20delicate%20cream%20lace%20dress%2C%20dramatic%20contrast%20of%20textures%2C%20warm%20studio%20lighting%2C%20minimalist%20cream%20background%2C%20luxury%20editorial%20fashion%20style%2C%20powerful%20feminine%20aesthetic&width=600&height=400&seq=article-8&orientation=landscape',
    author: '苏念真',
    date: '2026-07-10',
    readTime: '6 分钟',
    tags: ['皮革穿搭', '蕾丝穿搭', '风格混搭'],
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};